export default __webpack_public_path__ + "static/5-bb8f2834ac2edc36fa2990d8557b1499.png";